import { AddToMyFlow, RemoveFromMyFlow, SetFBAuth, SetInitialMyFlowData, SetUserTimetable } from 'types/MyFlow';
import {
  ADD_ITEM_TO_MYLOFW,
  REMOVE_ITEM_FROM_MYLOFW, REQUESTING_FB_AUTH_ID, SET_FB_AUTH_ID, SET_FETCHED_USER_TIMETABLE,
  SET_INITIAL_MY_FLOW_STORE_DATA, SET_MY_FLOW, UNSET_FB_AUTH_ID
} from '@flow/store/myflow/constants';

export const setInitialData = ({
  hashMapItems
}: SetInitialMyFlowData) => {
  return {
    type: SET_INITIAL_MY_FLOW_STORE_DATA,
    hashMapItems,
  };
};

export const setMyFlow = (events: string[]) => {
  return {
    type: SET_MY_FLOW,
    myFlow: events
  }
};

export const addToMyFlow = ({
  itemId,
  itemType,
}: AddToMyFlow) => {
  return {
    type: ADD_ITEM_TO_MYLOFW,
    itemId,
    itemType,
  };
};

export const removeFromMyFlow = ({
  itemId,
}: RemoveFromMyFlow) => {
  return {
    type: REMOVE_ITEM_FROM_MYLOFW,
    itemId,
  };
};

export const requestingFBAuth = () => {
  return {
    type: REQUESTING_FB_AUTH_ID,
  };
};

export const setFBAuth = ({
  userId
}: SetFBAuth) => {
  return {
    type: SET_FB_AUTH_ID,
    userId,
  }
};

export const unsetFBAuth = () => {
  return {
    type: UNSET_FB_AUTH_ID,
  }
};

export const setUserTimetable = ({
  timetable,
}: SetUserTimetable) => {
  return {
    type: SET_FETCHED_USER_TIMETABLE,
    timetable
  };
};


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/myflow/actions.ts